import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { enviroment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { GetResTermOfUse } from '../models/response/get-res-term-of-use';
import { PostReqTermAcceptance } from '../models/request/post-req-term-acceptance';
import { GetResTermAcceptance } from '../models/response/get-res-term-acceptance';

@Injectable({
  providedIn: 'root'
})
export class TermsOfUseService {

  apiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = `${enviroment.API_URL}/terms-of-use`;
  }

  getTermOfUse(): Observable<GetResTermOfUse>{
    const url = `${this.apiUrl}`;
    return this.http.get<GetResTermOfUse>(url).pipe();
  }

  getUserTermAcceptance(userSub: string): Observable<GetResTermAcceptance>{
    const url = `${this.apiUrl}/user/${userSub}`;
    return this.http.get<GetResTermAcceptance>(url).pipe();
  }

  postTermAcceptance(body: PostReqTermAcceptance): Observable<any>{
    const url = `${this.apiUrl}`;
    return this.http.post<Observable<any>>(url, body).pipe();
  }
}
